"use strict";

exports.__esModule = true;
exports.isLocationChoiceRedundantForStaff = exports.filterLocationsByStaff = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
var _filterStaffByLocation = require("../staff/filterStaffByLocation");
/**
 * Narrows a service's locations to those where at least one of its staff members actually
 * works.
 *
 * This is the same question `filterStaffMembersByLocation` answers, asked from the other
 * end — and asking it here is what stops the dead end happening at all: a location nobody
 * can serve is never offered, rather than being offered and then explained.
 *
 * Two locations are deliberately kept regardless:
 *
 * - **Non-business locations** (custom address, customer's place) have no working-hours
 *   location to compare against, exactly as in the staff filter.
 * - **Every location, when filtering would leave none.** A service whose staff have no
 *   coverage anywhere would otherwise get an empty location picker, which is a worse dead
 *   end than the one this avoids — nothing to choose and nothing explaining why. Failing
 *   open hands that case back to the staff step's empty state, which does explain it.
 *
 * A service with no staff members at all is likewise left alone: there is no staff
 * coverage to filter by, and hiding its locations would be filtering on absent data rather
 * than on a real answer.
 */
const filterLocationsByStaff = ({
  locations = [],
  staffMembers
}) => {
  if (!(staffMembers != null && staffMembers.length)) {
    return locations;
  }
  const locationsWithStaff = locations.filter(location => {
    var _location$business;
    if (location.type !== _types.LocationType.BUSINESS) {
      return true;
    }
    return (0, _filterStaffByLocation.filterStaffMembersByLocation)({
      staffMembers,
      selectedLocation: {
        type: _types.LocationType.BUSINESS,
        value: (_location$business = location.business) == null ? void 0 : _location$business.id
      }
    }).length > 0;
  });
  return locationsWithStaff.length ? locationsWithStaff : locations;
};

/**
 * True when filtering by staff coverage leaves a single business location.
 *
 * One option is not a choice, so the location step is skipped — the same reasoning as
 * `isStaffChoiceRedundantAtLocation`, and the same reason a service with a single business
 * location has never shown the step (`isServiceWithMultiBusinessLocations`, upstream in
 * `calculateLocationDisplay`).
 *
 * Only the number of *remaining* options counts, deliberately: asking whether the filter is
 * what narrowed them is a different question, and conflating the two is what once left a
 * single-staff service showing a picker with one entry in it.
 *
 * Counts business locations only, because those are the only ones the step offers.
 */
exports.filterLocationsByStaff = filterLocationsByStaff;
const isLocationChoiceRedundantForStaff = ({
  locations,
  staffMembers
}) => filterLocationsByStaff({
  locations,
  staffMembers
}).filter(location => location.type === _types.LocationType.BUSINESS).length === 1;
exports.isLocationChoiceRedundantForStaff = isLocationChoiceRedundantForStaff;
//# sourceMappingURL=filterLocationsByStaff.js.map